import { SortDescriptor } from "react-aria-components";

import { AWS_COLUMN_ID } from "../constants";
import { AwsIntegrationView } from "../useSearchCloudIntegrations/gql";

export const sortIntegrations = (items: AwsIntegrationView[], sortDescriptor: SortDescriptor) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    let valueA: string | undefined;
    let valueB: string | undefined;

    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch (sortDescriptor.column as AWS_COLUMN_ID) {
      case AWS_COLUMN_ID.NAME:
        valueA = a.name;
        valueB = b.name;
        break;
      case AWS_COLUMN_ID.SPACE:
        valueA = a.spaceDetails?.name;
        valueB = b.spaceDetails?.name;
        break;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
  });
};
